import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const varonis = defineConnector({
  identifier: "varonis",
  name: "Varonis",
  tagLine: "Data security and insider threat detection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}/api/authentication/api_keys/token`,
        method: "POST",
        headers: [{ name: "x-api-key", value: app.secret.apiKey }],
        formBody: { grant_type: "varonis_custom" },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Varonis web interface, generate an API key for the integration. This key is exchanged for a short-lived access token on each connection.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "hostname",
          label: "Varonis host",
          required: true,
          placeholder: "varonis.example.com",
          helperText: "The FQDN of your Varonis SaaS tenant.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/entitymodel/enum/5821`,
  },
});
